import React from "react";

const DesktopSocial = ({ config }) => (
  <div className="hidden-md-down desktop-social">
    {!!config.facebookURL && (
      <a target="_blank" href={config.facebookURL} rel="noreferrer">
        <i className={`fa fa-facebook ${config.footerSocialClass}`} />
      </a>
    )}
    {!!config.twitterURL && (
      <a target="_blank" href={config.twitterURL} rel="noreferrer">
        <i className={`fa fa-twitter ${config.footerSocialClass}`} />
      </a>
    )}
    {!!config.linkedInURL && (
      <a target="_blank" href={config.linkedInURL} rel="noreferrer">
        <i className={`fa fa-linkedin ${config.footerSocialClass}`} />
      </a>
    )}
    {!!config.googleURL && (
      <a target="_blank" href={config.googleURL} rel="noreferrer">
        <i className={`fa fa-google-plus ${config.footerSocialClass}`} />
      </a>
    )}
    {!!config.instagramURL && (
      <a target="_blank" href={config.instagramURL} rel="noreferrer">
        <i className={`fa fa-instagram ${config.footerSocialClass}`} />
      </a>
    )}
    {!!config.pinterestURL && (
      <a target="_blank" href={config.pinterestURL} rel="noreferrer">
        <i className={`fa fa-pinterest ${config.footerSocialClass}`} />
      </a>
    )}
    {!!config.youTubeURL && (
      <a target="_blank" href={config.youTubeURL} rel="noreferrer">
        <i className={`fa fa-youtube ${config.footerSocialClass}`} />
      </a>
    )}
  </div>
);

export default DesktopSocial;
